export default __webpack_public_path__ + "static/media/dot_blue.a2d6eb78.svg";